'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$$anon$90(evaluator$40) {
  this.Lapp_api_PharmacyAppUpdate$$anon$90__f_evaluator$16 = null;
  this.Lapp_api_PharmacyAppUpdate$$anon$90__f_evaluator$16 = evaluator$40;
}
export { $c_Lapp_api_PharmacyAppUpdate$$anon$90 as $c_Lapp_api_PharmacyAppUpdate$$anon$90 };
$c_Lapp_api_PharmacyAppUpdate$$anon$90.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate$$anon$90.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$$anon$90;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$$anon$90() {
}
export { $h_Lapp_api_PharmacyAppUpdate$$anon$90 as $h_Lapp_api_PharmacyAppUpdate$$anon$90 };
$h_Lapp_api_PharmacyAppUpdate$$anon$90.prototype = $c_Lapp_api_PharmacyAppUpdate$$anon$90.prototype;
$c_Lapp_api_PharmacyAppUpdate$$anon$90.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_PharmacyAppUpdate$$anon$90.prototype.apply__s_Option = (function() {
  var v = this.Lapp_api_PharmacyAppUpdate$$anon$90__f_evaluator$16.apply__O();
  return ((v instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_data_FrameworkDateTime) ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_api_PharmacyAppUpdate$$anon$90.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_api_PharmacyAppUpdate$$anon$90 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$$anon$90, "app.api.PharmacyAppUpdate$$anon$90", ({
  Lapp_api_PharmacyAppUpdate$$anon$90: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$$anon$90 as $d_Lapp_api_PharmacyAppUpdate$$anon$90 };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$$anon$90.js.map
